import Vendor from 'data/Vendor';
import React, { createContext, useContext } from 'react';

interface VendorContextType {
  selectedVendor: Vendor | null;
  updateVendor: (vendorName: string, brandId?: number) => void;
}

export const VendorContext = createContext<VendorContextType | undefined>(undefined);

interface ProviderProps {
  children: React.ReactNode;
  selectedVendor: Vendor | null;
  updateVendor: (vendorName: string, brandId?: number) => void;
}

export const VendorProvider = ({ children, selectedVendor, updateVendor }: ProviderProps) => {
  return (
    <VendorContext.Provider value={{ selectedVendor, updateVendor }}>
      {children}
    </VendorContext.Provider>
  );
};

/**
 * Custom hook to access the selected vendor and update function
 * @returns {VendorContextType} The selected vendor and update function
 * @throws {Error} If used outside of VendorProvider
 */
export const useVendor = (): VendorContextType => {
  const context = useContext(VendorContext);
  if (context === undefined) {
    throw new Error('useVendor must be used within a VendorProvider');
  }
  return context;
};
